"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    closeOnClick = require("../wrappers/closeOnClick.js"),
    Tooltip = function Tooltip(t) {
  var e = classnames("blx-tooltip-" + t.position, {
    "blx-hidden": !t.isOpen,
    "blx-light-bg": t.lightBg,
    "blx-dark-bg": !t.lightBg,
    "blx-tooltip-titled-message": t.title,
    "blx-tooltip-message": !t.title
  });
  return React.createElement("div", {
    style: t.style,
    className: classnames("blx-tooltip", t.className),
    ref: t.forwardedRef
  }, React.createElement("button", {
    className: "blx-tooltip-trigger",
    onClick: function onClick(e) {
      e.currentTarget.focus(), t.toggle(e);
    }
  }, t.trigger), React.createElement("div", {
    className: e
  }, t.title && React.createElement("h5", {
    className: "blx-tooltip-titled-message-title"
  }, t.title), React.createElement("p", null, t.text)));
};

Tooltip.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  trigger: PropTypes.object,
  lightBg: PropTypes.bool,
  position: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isOpen: PropTypes.bool
}, Tooltip.defaultProps = {
  style: null,
  className: "",
  title: "",
  trigger: null,
  lightBg: !1,
  position: "bottom",
  text: "",
  isOpen: !1
}, module.exports = closeOnClick(Tooltip);